export type SalesforceCloud =
  | 'Gamma'
  | 'Kappa'
  | 'CI'
  | 'Iota'
  | 'Beta'
  | 'OpenSync'
  | 'Dogfood'
  | 'Phi'
  | 'dev-4'
  | 'dev-8'
  | 'func4'

/**
 * When one of these products is purchased, portal is not in trial
 */
export const salesforcePortalProducts = [
  'Haystack',
  'Frontline',
  'Panorama',
  'Signal',
  'HomePass',
  'WorkPass',
  'Harvest',
  'Clarity',
  'Generate',
  'Nurture',
  'Uprise',
  'Flex',
]

export const salesforcePrimaryOnlyClouds: SalesforceCloud[] = [
  'Gamma',
  'Kappa',
  'CI',
  'Iota',
  'Phi',
  'dev-4',
  'dev-8',
  'func4',
]
